export const locale = {
    lang: 'en',
    data: {
        PROJECTS_DIALOGS_NEW_DIALOG_ADD_PARAGRAPHE: 'Add Paragraph',
        PROJECTS_DIALOGS_NEW_DIALOG_TITLE: 'Title',
        PROJECTS_DIALOGS_NEW_DIALOG_SAVE: 'Save',
        PROJECTS_DIALOGS_NEW_DIALOG_CANCEL: 'Cancel',
    }
};
